var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.action_for == 'user_imports')?_c('v-btn',{attrs:{"disabled":_vm.disableBulkUserUpload,"color":"blue darken-1","text":""},on:{"click":function($event){return _vm.saveDialog()}}},[_vm._v(" Save ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }